'use strict'
var notifications = angular.module('notificationsModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
]);
require('./allnotifications/js/directive/allnotificationsDirective.js')(notifications);
require('./allnotifications/js/allnotificationsController.js')(notifications);
require('./notificationsettings/js/directive/notificationSettingsDirective.js')(notifications);
require('./notificationsettings/js/notificationSettingsController.js')(notifications);




//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/notificationsModule/notificationsModule.js
// module id = 532
// module chunks = 0